/**
 * @generated SignedSource<<08204d26d005f2f11f949aa372dff727>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ReaderFragment } from 'relay-runtime';
export type PassContentConfigType = "PassContent_Always" | "PassContent_OnPercentage" | "%future added value";
import { FragmentRefs } from "relay-runtime";
export type PassContentConfigEditor_TreeNodeFragment$data = {
  readonly id: string;
  readonly typeDefinition: {
    readonly passConfig?: {
      readonly configType: PassContentConfigType;
      readonly requiredPercentage?: number;
      readonly " $fragmentSpreads": FragmentRefs<"OnPercentagePassContentConfigForm_OnPercentagePassContentConfigFragment">;
    };
  };
  readonly " $fragmentSpreads": FragmentRefs<"OnPercentagePassContentConfigForm_TreeNodeFragment">;
  readonly " $fragmentType": "PassContentConfigEditor_TreeNodeFragment";
};
export type PassContentConfigEditor_TreeNodeFragment$key = {
  readonly " $data"?: PassContentConfigEditor_TreeNodeFragment$data;
  readonly " $fragmentSpreads": FragmentRefs<"PassContentConfigEditor_TreeNodeFragment">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "PassContentConfigEditor_TreeNodeFragment",
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "id",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "concreteType": null,
      "kind": "LinkedField",
      "name": "typeDefinition",
      "plural": false,
      "selections": [
        {
          "kind": "InlineFragment",
          "selections": [
            {
              "alias": null,
              "args": null,
              "concreteType": null,
              "kind": "LinkedField",
              "name": "passConfig",
              "plural": false,
              "selections": [
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "configType",
                  "storageKey": null
                },
                {
                  "kind": "InlineFragment",
                  "selections": [
                    {
                      "alias": null,
                      "args": null,
                      "kind": "ScalarField",
                      "name": "requiredPercentage",
                      "storageKey": null
                    }
                  ],
                  "type": "OnPercentagePassContentConfig",
                  "abstractKey": null
                },
                {
                  "args": null,
                  "kind": "FragmentSpread",
                  "name": "OnPercentagePassContentConfigForm_OnPercentagePassContentConfigFragment"
                }
              ],
              "storageKey": null
            }
          ],
          "type": "ContentTypeDefinition",
          "abstractKey": "__isContentTypeDefinition"
        }
      ],
      "storageKey": null
    },
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "OnPercentagePassContentConfigForm_TreeNodeFragment"
    }
  ],
  "type": "TreeNode",
  "abstractKey": null
};

(node as any).hash = "279c780d4ec369d908e892ec2b54a330";

export default node;
